const has = Object.prototype.hasOwnProperty;

function decode(input: string) {
  try {
    return decodeURIComponent(input.replace(/\+/g, ' '));
  } catch (e) {
    return null;
  }
}

function encode(input: string | number | boolean) {
  try {
    return encodeURIComponent(input);
  } catch (e) {
    return null;
  }
}

interface QueryObject {
  [x: string]: any;
}

export class QueryString {
  static parse(query: string) {
    const parser = /([^=?#&]+)=?([^&]*)/g;
    const result: QueryObject = {};
    let part;

    while ((part = parser.exec(query))) {
      const key = decode(part[1]);
      const value = decode(part[2]);
      if (key === null || value === null || key in result) continue;
      result[key] = value;
    }
    return result;
  }
  static stringify(obj: QueryObject, prefix = '') {
    const pairs: string[] = [];
    let value: any;
    let key: string | null;
    if (typeof prefix !== 'string') prefix = '?';

    for (key in obj) {
      if (has.call(obj, key)) {
        value = obj[key];

        if (!value && (value === null || value === undefined || isNaN(value))) {
          value = '';
        }
        key = encode(key);
        value = encode(value);

        if (key === null || value === null) continue;
        pairs.push(`${key}=${value}`);
      }
    }
    return pairs.length ? prefix + pairs.join('&') : '';
  }
}

export const qs = QueryString;
